import { SKIP_RENDER } from '@mediashop/app/constants/semanticConstants';
import { FormattedMessage } from 'react-intl';
import BundleItem from '../BundleItem/BundleItem';
import { BundleProps } from './index';
import { ErrorBoundary } from '@mediashop/app';

const componentName = 'bundle';

const Bundle = ({ sets }: BundleProps): JSX.Element | null => {
    const setWithSlug = sets.filter((set) => set.slug);

    if (!setWithSlug.length) {
        return SKIP_RENDER;
    }

    return (
        <div className={componentName}>
            <div className={`${componentName}__title`}>
                <FormattedMessage id="product.bundleTitle" />
            </div>
            <div className={`${componentName}__item-wrapper`}>
                {setWithSlug.map((set) => (
                    <ErrorBoundary key={set.key}>
                        <BundleItem product={set} />
                    </ErrorBoundary>
                ))}
            </div>
        </div>
    );
};

export default Bundle;
